/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Import_Next_LabelInputs */



/**
* | output |
* | --- |
* | "Next" |
*
* @param {File_Import_Next_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_import_next_label = /** @type {((inputs?: File_Import_Next_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Import_Next_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Next")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nächste")
	if (locale === "it") return /** @type {LocalizedString} */ ("Prossimo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Следующий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Próximo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("下一个")
	if (locale === "ja") return /** @type {LocalizedString} */ ("次")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अगला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Próximo")
	return /** @type {LocalizedString} */ ("Next")
});